export default __webpack_public_path__ + "static/media/co8.714ed66a.png";